import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconPhoneSvg } from "./IconPhoneSvg.mjs";
const IconPhone = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconPhoneSvg, ...svgProps }) });
export {
  IconPhone
};
